import { registerLocaleData } from '@angular/common'
import localeDeAt from '@angular/common/locales/de'
import { bootstrapApplication } from '@angular/platform-browser'
import { datadogRum } from '@datadog/browser-rum'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from './environments/environment'

registerLocaleData(localeDeAt, 'de')

bootstrapApplication(AppComponent, appConfig)

if (environment.production) {
  datadogRum.init({
    applicationId: 'fcd0a580-27e6-4bf9-8afc-f51b3758d8f5',
    clientToken: 'pubde2bc35a096f5f9394bd13a5d4f3489b',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.eu',
    service: 'oew-adressmaster-prod',
    env: 'prod',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 20,
    sessionReplaySampleRate: 20,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input',
  })
}
